module.exports = __webpack_public_path__ + "img/img_aboutus_top@2x.a1ea9bfa.png";